import { ReactElement } from 'react'
import { DoubleSide, Euler, MeshBasicMaterial } from 'three'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { Svg } from '@react-three/drei'

interface Props {
  hasLiveLoad: boolean
  pointForIcon: ImmutableVector3
  color?: string
  rotation?: Euler
  opacity?: number
}

const LiveLoadIcon = ({
  hasLiveLoad,
  pointForIcon,
  color = '#000000',
  rotation = new Euler(0, 0, 0), // No rotation to keep it vertical
  opacity = 1,
}: Props): ReactElement | null => {
  if (!hasLiveLoad) return null

  // Encode the SVG content to handle special characters
  // const encodedSvg = encodeURIComponent(
  //   `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
  //     color,
  //   )}" d="M21 11h-4.17l2.59-2.59L18 7l-3.99 4H13V6.83l4-3.99L15.59 2 13 4.59V0h-2v4.59L8.41 2 7 3.41l4 3.99V11h-1.99L5 7l-1.41 1.41L6.17 11H2v2h4.17l-2.58 2.59L5 17l3.99-4H11v4.17l-4 3.99L8.41 22 11 19.41V24h2v-4.59L15.59 22 17 20.59l-4-3.99V13h1.99l3.99 4 1.41-1.41L17.83 13H22v-2z"/></svg>`,
  // )

  const encodedSvg = encodeURIComponent(
    `
<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><rect fill="none" height="24" width="24"/><path d="M21.19,21.19L2.81,2.81L1.39,4.22L3,5.83V19c0,1.1,0.9,2,2,2h13.17l1.61,1.61L21.19,21.19z M8.25,19H5V7.83l2,2v3.67 c0,0.55,0.45,1,1,1h0.25V19z M9.75,19v-4.5H10c0.46,0,0.82-0.31,0.94-0.73l3.31,3.31V19H9.75z M11,8.17L5.83,3H19c1.1,0,2,0.9,2,2 v13.17l-2-2V5h-2v8.5c0,0.19-0.07,0.36-0.16,0.51L13,10.17V5h-2V8.17z"/></svg>
  `,
  )

  // <rect x="5.38681" width="1" height="7.55716" transform="rotate(45.4639 5.38681 0)" fill="black"/>
  const svgData = `data:image/svg+xml,${encodedSvg}`

  return (
    <Svg
      src={svgData}
      position={[pointForIcon.v.x, pointForIcon.v.y, pointForIcon.v.z]}
      scale={0.01}
      rotation={rotation}
      fillMaterial={new MeshBasicMaterial({ color, side: DoubleSide, opacity, transparent: true })}
    />
  )
}

export default LiveLoadIcon
